'use client';

import React from 'react';
import { ExperienceType } from '../types';
import ActivitiesAndAmenities from '@/components/stay-experience/ActivitiesAndAmenities';
import { Activity } from '@/types/stayExperienceCardTypes';

interface ExperienceActivitiesProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceActivities: React.FC<ExperienceActivitiesProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'stay') return null;

  const exp = experience as {
    activities?: Activity[];
    activityDescription?: string;
  };

  const activities = exp?.activities || [];
  const activityDescription = exp?.activityDescription || '';

  if (!Array.isArray(activities) || activities.length === 0) return null;

  return (
    <ActivitiesAndAmenities
      activities={activities}
      description={activityDescription}
    />
  );
};
